export function printCeremonySummary(content: HTMLElement, onError: () => void) {
  const frame = document.createElement('iframe')
  frame.title = 'Tisk souhrnu obřadu'
  frame.setAttribute('sandbox', 'allow-modals allow-same-origin')
  frame.style.cssText = 'position:fixed;width:0;height:0;border:0;left:-10000px'
  frame.onload = () => {
    const target = frame.contentWindow
    if (!target) {
      frame.remove()
      onError()
      return
    }
    target.addEventListener('afterprint', () => frame.remove(), { once: true })
    try {
      target.focus()
      target.print()
    } catch {
      frame.remove()
      onError()
    }
  }
  frame.srcdoc = `<!doctype html><html lang="cs"><head><meta charset="utf-8"><title>Souhrn obřadu</title><style>
    @page{size:A4;margin:18mm}body{font:11pt/1.5 system-ui,sans-serif;color:#222;margin:0;overflow-wrap:anywhere}h1{font:28pt Georgia,serif;margin:0 0 8pt}h2{font:17pt Georgia,serif;border-bottom:1px solid #ddd;padding-bottom:6pt;margin:22pt 0 10pt;break-after:avoid}h3{font-size:11pt;margin:0 0 3pt}p{margin:4pt 0}dl{margin:0}dt{color:#666;font-size:9pt}dd{margin:0 0 10pt}ol,ul{padding-left:20pt}li{padding:5pt 0;break-inside:avoid}.summary-grid{display:grid;grid-template-columns:1fr 1fr;gap:18pt}.summary-note{white-space:pre-wrap}.summary-item{break-inside:avoid;margin-bottom:10pt}section{break-inside:auto}a{color:inherit;text-decoration:none}
    </style></head><body>${content.outerHTML}</body></html>`
  document.body.append(frame)
}
